
var sw = window.innerWidth;
var sh = window.innerHeight;
var header = document.querySelector("header");
var sticky = 0;

// Font Resizer ------------------- Start
  function fontResizer() {
    var perc = parseInt(sw) / 120;
    document.body.style.fontSize = perc + 'px';
  }
  

// Loader ------------------- Start
  function pageLoader() {
    // document.querySelector("html").classList.add("loadjs");
    setTimeout(function () {
      if(document.querySelector(".loader-first")) {
        document.querySelector(".loader-first").style.display = "none";
        document.querySelector("html").classList.remove("loadjs");
      }
    }, 4000);
  }

  // Window on Load ----------------- Start
  window.onload = function () {
    pageLoader();
    if (sw > 1199) {
      fontResizer();
    }
  };

// Window On Resize ----------------- Start
(function () {
  window.addEventListener('resize', (event) => {
    sw = window.innerWidth;
    sh = window.innerHeight;
    if (sw > 1025) {
      if (sw < 1400 && sw > 1300 && sh > 900) {} else {
        fontResizer();
      }
    }
  });
})();




// Landscape Mode off ---------------- Start
  const mql = window.matchMedia("(orientation:landscape)");
  mql.addEventListener("change", (event) => {
    if (event.matches) {
      if (innerWidth < 930) {
        // console.log("Now in landscape orientation");
        document.getElementById("portrait-warning").style.display = "flex";
      }
    } else {
      // console.log("Now in portrait orientation");
      document.getElementById("portrait-warning").style.display = "none";
    }
  });


// Sticky Header ---------------- Start
(function () {
  if (document.querySelector('.header')) {
    function stickyHeader() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }
    window.addEventListener('scroll', (event) => {
      stickyHeader();
    });
  }
})();





// SVG Convert Code
window.addEventListener("load", function() {
  (function() {
    if(document.querySelector(".svg-convert")) {
      let svgs = document.querySelectorAll('img.svg-convert');
      svgs.forEach((el) => {
        const imgID = el.getAttribute('id');
        const imgClass = el.getAttribute('class');
        const imgURL = el.getAttribute('src');
    
        fetch(imgURL)
          .then((response) => response.text())
          .then(data => {
              const parser = new DOMParser();
              const xmlDoc = parser.parseFromString(data, 'text/html');
              let svg = xmlDoc.querySelector('svg');
              if (typeof imgID !== 'undefined') {
                  svg.setAttribute('id', imgID);
              }
    
              if (typeof imgClass !== 'undefined') {
                  svg.setAttribute('class', imgClass + ' svg-converted');
              }
    
              svg.removeAttribute('xmlns:a');
    
              el.parentNode.replaceChild(svg, el);
          })
      });
    }
  }) ();

});


// Navigation slide Active on a mobile and tab and ipad ---------------- Start
(function () {
  if (document.querySelector('#toggle')) {
    let toggleMenu = document.querySelector('#toggle');
    let htmlEl = document.querySelector("html");

    toggleMenu.addEventListener("click", (event) => {
      // console.log('this', event)
      let _this = event.target;
      _this.classList.toggle('active');
      document.querySelector('.navigation').classList.toggle('open')
      htmlEl.classList.toggle("overflow-hidden");
    })
  }
})();


// navigation accordion
(function() {
  if(sw < 1200) {
    let dropdown = document.querySelectorAll(".dropdown");
    dropdown.forEach(function(dp) {
      let dropdownItem = dp.closest(".menu__menuitem");
      dropdownItem.classList.add("dropdown-active");
    });
  
    let accordionNav = document.querySelectorAll(".menu__menuitem.dropdown-active");
    let iterator;

    for (iterator = 0; iterator < accordionNav.length; iterator++) {
      accordionNav[iterator].querySelector(".menu__menuitem__icon").addEventListener("click", function (e) {
        e.stopPropagation();
        let currentItem = e.target;

        // console.log(currentItem)

        let panel = this.nextElementSibling;
        if(currentItem.classList.contains('open')) {
          currentItem.classList.remove("open");
          panel.style.maxHeight = '0px';
        } else {
          let mainItem = currentItem.closest(".menu").querySelectorAll(".menu__menuitem__icon");
            mainItem.forEach(function(itm) {
            itm.classList.remove("open");
            itm.nextElementSibling.style.maxHeight = '0px';
          });
          currentItem.classList.add("open");
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    }
  }
})();



// animate Observer------------Start
(function() {
  if (window.innerWidth > 767) {
    let anim = [...document.querySelectorAll(".animate")];
  
    let options = {
      rootMargin: "0px",
      threshold: 0.2,
    };
  
    let animate = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animation = `anim 1s ${entry.target.dataset.delay} forwards ease-out`;
        }
      });
    };
  
    let observer = new IntersectionObserver(animate, options);
  
    anim.forEach((item, idx) => {
      observer.observe(item);
    });
  }
})();


// Lazy Load Img observer
(function() {
  document.addEventListener("DOMContentLoaded", () => {
    const imgElements = document.querySelectorAll("img[data-src]");
  
    const lazyLoadingImage = (entries, observer2) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.src = entry.target.dataset.src;
        entry.target.addEventListener("load", () => {
          entry.target.classList.remove("lazy-img");
          observer2.unobserve(entry.target);
        });
      });
    };
    const lazyLoadingObserver = new IntersectionObserver(lazyLoadingImage, {
      threshold: 0,
      rootMargin: "0px 0px 150px 0px",
    });
    imgElements.forEach((img) => lazyLoadingObserver.observe(img));
  });
})();



// clip path observer
(function() {

  if(window.innerWidth > 767) {

    let imageObserver = [...document.querySelectorAll(".img__observer")];
    let option = {
      rootMargin: "-200px",
      threshold: 0.2,
    };
  
    let setItemActive = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    };
  
    let observer2 = new IntersectionObserver(setItemActive, option);
  
    imageObserver.forEach((item1, idx) => {
      observer2.observe(item1);
    });


  }

})();



// main navigation hover
(function () {
  if (sw > 1199) {

    let menuitems = document.querySelectorAll(".navigation > .menu > .menu__menuitem");

    menuitems.forEach(function(menuitem) {
      if(menuitem.children[2]) {
        
        let first__menuLink = menuitem.querySelector(".navigation--main .menu__menuitem--menulink ");
            first__menuLink.classList.add("active");
        
        let firstSrc =  first__menuLink.dataset.src,
            firstTitle = first__menuLink.dataset.title;

        let currentNavigationMain = menuitem.querySelector(".navigation-wrapper--main"),
            currentFigure = currentNavigationMain.querySelector(".navigation--main__content__card__figure .menu-img"),
            currentTitleEl = currentNavigationMain.querySelector(".navigation--main__content__card__text");

        currentFigure.setAttribute("src",firstSrc);
        currentTitleEl.textContent = firstTitle;

      }

    });
    

    let mainItems = document.querySelectorAll(".navigation--main .menu__menuitem--menulink");
      
    mainItems.forEach(function(item) {

      item.addEventListener("mouseover", function (evt) {
        evt.stopPropagation();
        if(evt.target.matches(".menu__menuitem--menulink")) {
          mainItems.forEach(function (itm) {
            itm.classList.remove("active");
          });

          evt.target.classList.add("active");

          let currentCardSrc = evt.target.dataset.src,
              currentDataTitle = evt.target.dataset.title;


          let currentNavigationMain = evt.target.closest(".navigation-wrapper--main"),
              currentFigure = currentNavigationMain.querySelector(".navigation--main__content__card__figure .menu-img"),
              currentTitleEl = currentNavigationMain.querySelector(".navigation--main__content__card__text");
  
              currentFigure.setAttribute("src",currentCardSrc);
              currentTitleEl.textContent = currentDataTitle;


              let navigationMain = evt.target.closest(".navigation--main");
              navigationMain.querySelector(".navigation--main__content__card").classList.add("active");


        }

      });

      item.addEventListener("mouseout", function(evt) {
        evt.stopPropagation();
        if(evt.target.matches(".menu__menuitem--menulink")) {
          let navigationMain = evt.target.closest(".navigation--main");
          navigationMain.querySelector(".navigation--main__content__card").classList.remove("active");
          

          menuitems.forEach(function(menuitem) {
            if(menuitem.children[2]) {

              
              let first__menuLink = menuitem.querySelector(".navigation--main .menu__menuitem--menulink ");
                  first__menuLink.classList.add("active");
              
              let firstSrc =  first__menuLink.dataset.src,
                  firstTitle = first__menuLink.dataset.title;
      
              let currentNavigationMain = menuitem.querySelector(".navigation-wrapper--main"),
                  currentFigure = currentNavigationMain.querySelector(".navigation--main__content__card__figure .menu-img"),
                  currentTitleEl = currentNavigationMain.querySelector(".navigation--main__content__card__text");

                  // console.log(currentFigure)
      
              currentFigure.setAttribute("src",firstSrc);
              currentTitleEl.textContent = firstTitle;
      
            }
      
          });
        }


      });








    });
  }
})();










// -------------------- above code will be common for all websites --------------------------

// example for sample
// if (sw < 767) {
//     if (document.querySelector('.our-partners__partner-slider')) {
//         var partnerSlider = new Swiper(".our-partners__partner-slider", {
//             slidesPerView: 2,
//             loop: true,
//             speed: 2000,
//             autoplay: {
//                 enable: true,
//                 delay: 2000,
//                 disableOnInteraction: false,
//             },
//         });
//     }
// }


if (document.querySelector('.brand-features')) {
  var swiperBrandThumb = new Swiper(".brand-features__thumb", {
    spaceBetween: 0,
    slidesPerView: 2,
    freeMode: true,
    watchSlidesProgress: true,
    grabCursor: true,
    observeParents: true,
    observer: true,
    breakpoints: { 
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
     }

  });

  var swiperBrandFeatures = new Swiper(".brand-features__Slider", {
    spaceBetween: 0,
    speed: 1500,
    parallax: true,
    observeParents: true,
    observer: true,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    thumbs: {
      swiper: swiperBrandThumb,
    },
  });
 }




 if(document.querySelector(".what-we__slider-wrapper")) {
  var what__slider = new Swiper(".what-we__slider-wrapper .swiper", {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 20,
    init: false,
    observeParents: true,
    observer: true,
    speed: 2000,
    // autoplay: {
    //   delay: 2500,
    //   disableOnInteraction: false,
    // },
    breakpoints: { 
      576: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3.38,
        spaceBetween: 40,
        // centeredSlides: true,
      },
     }
  });

   const tabs = document.querySelectorAll('.c-tab .rectangle-btn');
   tabs.forEach(tab => {
     tab.addEventListener('click', () => {
       // Remove the 'active' class from all tabs
       tabs.forEach(t => t.classList.remove('active'));   
       // Add the 'active' class to the clicked tab
       tab.classList.add('active');
   
       // Get the category from the data-category attribute
       const category = tab.getAttribute('data-category');

      document.querySelectorAll('.what-we__slider-wrapper .swiper-slide').forEach(slide => {
        if (slide.classList.contains(category)) {
          slide.style.display = 'block'; // Show matching slides
        } else {
          slide.style.display = 'none'; // Hide non-matching slides
        }
      });
  
      // Update Swiper after showing/hiding slides
      what__slider.update();  
     });
   });
   
  // Initialize Swiper
  what__slider.init();
 }


 function Cursor() {
  let boxes = document.querySelectorAll(".what-we__slider-wrapper .service-card"),
      section = document.querySelector(".what-we__slider-wrapper"),
      cursorElement = document.querySelector(".cursor");

      boxes.forEach(function(box) {
          box.addEventListener('mousemove', function(e) {
              e.stopPropagation();
              if(e.target.closest(".what-we__slider-wrapper .swiper-slide")) {
                  cursorElement.classList.add("show");
                  cursorElement.style.left = (e.clientX)+'px';
                  cursorElement.style.top = (e.clientY)+'px';
              }
          });
      });

      section.addEventListener('mouseout', function(e) {
          e.stopPropagation();
          cursorElement.classList.remove("show");
      });
}

Cursor();

function Modal(modalMainWrapper, backdrop, show) {
  if(document.querySelector('.modal')) {
    let modal = document.querySelector(modalMainWrapper),
    modal_backdrop = document.querySelector(backdrop),
    show_modals = document.querySelectorAll(show),
    rootEl = document.querySelector("html");

    show_modals.forEach(function(show_modal) {
      show_modal.addEventListener("click", function(e) {
          e.stopPropagation();
          if(!this.classList.contains("show")) {
            modal.classList.add("show");
            modal_backdrop.classList.add("show");
            this.classList.add("show");
            rootEl.classList.add("overflow-hidden");
          }
          else {
            modal.classList.remove("show");
            modal_backdrop.classList.remove("show");
            this.classList.remove("show");
            rootEl.classList.remove("overflow-hidden");
          }
  
      });
    });
  
    
    document.addEventListener("click", function(e) {
        e.stopPropagation();
        if(e.target.closest(".modal")) {
            // console.log("modal")
            if(e.target.matches(".modal__cancel")) {
                // console.log(e.target.matches(".modal__cancel")  )
                modal.classList.remove("show");
                modal_backdrop.classList.remove("show");
                show_modals.forEach(function(show_modal) {
                  show_modal.classList.remove("show");
                });
                rootEl.classList.remove("overflow-hidden");
            }
        }
        else {
            modal.classList.remove("show");
            modal_backdrop.classList.remove("show");
            show_modals.forEach(function(show_modal) {
              show_modal.classList.remove("show");
            });
            rootEl.classList.remove("overflow-hidden");
        }
    });
  }
}

Modal(".modal--enquire", ".modal-backdrop--enquire", ".show-modal--enquire");

Modal(".modal--search", ".modal-backdrop--search", ".show-modal--search");



// modal for projects
function ModalProject(modalMainWrapper, backdrop, show) {

  let modal = document.querySelector(modalMainWrapper),
  modal_backdrop = document.querySelector(backdrop),
  show_modals = document.querySelector(show),
  show_modalsParent = show_modals.closest(".container-s"),
  rootEl = document.querySelector("html");

  show_modalsParent.addEventListener("click", function(e) {
      e.stopPropagation();
      if(e.target.matches(".show-modal--project")) {
        modal.classList.add("show");
        modal_backdrop.classList.add("show");
        rootEl.classList.add("overflow-hidden");

      }
  });

  
  document.addEventListener("click", function(e) {
      e.stopPropagation();
      if(e.target.closest(".modal")) {
          // console.log("modal")
          if(e.target.matches(".modal__cancel")) {
              // console.log(e.target.matches(".modal__cancel")  )
              modal.classList.remove("show");
              modal_backdrop.classList.remove("show");
              rootEl.classList.remove("overflow-hidden");
          }
      }
      else {
          modal.classList.remove("show");
          modal_backdrop.classList.remove("show");
          rootEl.classList.remove("overflow-hidden");
      }
  });
  
}

if(document.querySelector('.modal--project')) { 
  ModalProject(".modal--project", ".modal-backdrop--project", ".show-modal--project");
}























